module.exports = __webpack_public_path__ + "img/genesis-logo.ae23146e.webp";